<template>
  <div id="serviceNewList">
    <div ref="headerHeight" class="header">
      <div class="box">
        <div class="search-wrap">
          <van-search class="flex1"
                      v-model="params.title"
                      placeholder="请输入搜索关键词"
                      shape="round"
                      background="#ffffff"
                      :clearable="false"
                      @search="onSearch"/>
          <van-icon class="filter-btn iconfont"
                    class-prefix="icon"
                    name="shaixuan"
                    color="#333333"
                    size="20px"
                    @click="showFilter"/>

        </div>
        <div class="filter-box" v-if="filterShow">
          <van-tabs title-active-color="var(--main-color)" color="var(--main-color)">
            <van-tab title="公告类型">
              <div class="filter-body selector-item-box">
            <span class="tag"
                  v-for="(type,index) in types"
                  :key="index"
                  :class="{'active' : type.tagid === params.afficheType}"
                  @click="selectTypes(type.tagid)">{{ type.tagname }}</span>
              </div>
            </van-tab>
            <van-tab title="发布部门">
              <div class="filter-body flex-between">
                <div class="left-menu">
                  <div
                      v-for="(org,index) in orgs"
                      :key="index"
                      class="menu-item center"
                      :class="{'active' : org.id === orgid}"
                      @click="selectOrgs(org.id)">{{ org.text }}
                  </div>
                </div>
                <div class="right-block">
                  <p v-for="(dept,index) in curDepts"
                     :key="index"
                     :class="{'active' : dept.id === params.orgId}"
                     @click="selectDepts(dept.id)">{{ dept.text }}</p>
                </div>
              </div>
            </van-tab>
          </van-tabs>
          <div class="btn-control">
            <button class="btn-reset" @click="reset">重置</button>
            <button class="btn-confirm" @click="confirm">确定</button>
          </div>

        </div>
        <div class="mask" @click="showFilter" v-if="filterShow"></div>
        <div class="tab-box">
          <van-tabs @click="toggleUnread" title-active-color="var(--main-color)" color="var(--main-color)" animated>
            <van-tab title="全部" name="all"/>
            <van-tab title="未读" name="unRead"/>
          </van-tabs>
        </div>
      </div>
    </div>
    <div class="news-items" v-if="!emptyShow">
      <van-pull-refresh v-model="loading" @refresh="onRefresh">
        <van-list
            v-model="loading"
            :finished="finished"
            @load="onLoad"
            :immediate-check="false"
            finished-text="没有更多了"
        >
          <NewsItem v-for="(item, index) in list" :key="index" :data="item"/>
        </van-list>
      </van-pull-refresh>
    </div>
    <Error :type="'empty'" v-else></Error>
  </div>
</template>

<script>
import {Tab, Popup, Search, PullRefresh, List, Sticky} from "vant";
import {queryServiceNewsForUser} from "@/api/home";
import {queryServiceDepts, queryServiceTypes} from "@/api/home";

export default {
  components: {
    NewsItem: () => import('./NewsItem'),
    [Tab.name]: Tab,
    [Popup.name]: Popup,
    [Search.name]: Search,
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
    [Sticky.name]: Sticky
  },
  data() {
    return {
      active: 0,
      filterShow: false,
      orgid: '',
      depts: [],
      curDepts: [],
      types: [],
      params: {
        title: undefined,
        orgId: undefined,
        afficheType: undefined,
        pageSize: 5,
        pageIndex: 0
      },
      list: [],
      loading: false,
      finished: false,
      isLoading: false,
      totalPage: 0,
      emptyShow: false
    }
  },
  computed: {
    orgs() {
      return this.depts.filter(item => {
        return item.type == '1';
      })
    },
  },
  created() {
    this.onLoad();
    queryServiceTypes().then(resp => {
      this.types = resp.data;
    })
    queryServiceDepts().then(resp => {
      if (resp.code && resp.code == 200) {
        if (resp.data) {
          this.depts = resp.data;
          this.selectOrgs(this.depts[0].id);
        }
      }
    })
  },
  methods: {
    onLoad() {
      const that = this;
      let list = this.list;
      if (!that.finished) {
        this.loading = true;
        queryServiceNewsForUser(this.params).then(resp => {
          let result = resp.data;
          that.list = list.concat(result.data);
          that.totalPage = result.totalPage;
          that.loading = false;
          if (that.params.pageIndex >= that.totalPage) {
            that.finished = true;
          } else {
            that.params.pageIndex++;
          }
          if (that.list.length > 0) {
            this.emptyShow = false;
          } else {
            this.emptyShow = true;
          }
        })
      }
    },
    //下拉刷新
    onRefresh() {
      this.loading = true;
      this.finished = false;
      this.list = [];
      this.params.pageIndex = 0;
      this.onLoad();
    },

    toggleUnread(name) {
      if (name === 'unRead') {
        this.params.unRead = 'true';
        this.onRefresh();
      } else {
        this.params.unRead = undefined;
        this.onRefresh();
      }
    },
    //获取搜索关键词
    onSearch(val) {
      if (val) {
        this.params.title = val ? val : undefined;
        this.onRefresh();
      }
    },
    //显示筛选
    showFilter() {
      this.filterShow = !this.filterShow;
    },
    selectTypes(e) {
      this.params.afficheType = e;
    },
    selectOrgs(e) {
      this.orgid = e;
      this.curDepts = this.depts.filter(item => {
        return item.pid === this.orgid;
      })
    },
    selectDepts(e) {
      this.params.orgId = e;
    },
    reset() {
      this.params = {
        title: undefined,
        orgId: undefined,
        afficheType: undefined,
      };
      this.filterShow = false;
      this.onRefresh();
    },
    confirm() {
      this.onRefresh();
      this.filterShow = false;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/css/theme/theme.scss";
.header {
  height: 97px;
  padding: 0 10px 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: #ffffff;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999;

  .mask {
    display: block;
    width: 100%;
    height: 100vh;
    top: 0;
    left: 0;
    z-index: 3;
    background-color: rgba(0, 0, 0, 0.2);
  }

  .box {
    width:100%;
    height: 77px;
    position: relative;
    z-index: 2;
    background-color: inherit;
  }

  .search-wrap {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    align-content: center;
    padding: 0 15px;
    background-color: inherit;

    .van-search {
      padding: 10px 0;

      .van-search__content {
        background-color: #F7F7F7 !important;
      }
    }
  }

  .filter-btn {
    margin-left: 10px;
  }

  .filter-box {
    width: 100%;
    left: 0;
    top: 53px;
    position: absolute;
    z-index: 4;
    background-color: #ffffff;
    box-sizing: border-box;

    .selector-item-box {
      display: flex;
      flex-wrap: wrap;
      overflow-x: hidden;
      overflow-y: auto;

      span {
        display: inline-flex;
        height: 32px;
        line-height: 32px;
        padding: 0 15px;
        margin-right: 10px;
        margin-bottom: 10px;
        border-radius: 16px;
        background: #f7f7f7;
        color: #999999;
        @extend .font13;

        &.active {
          background: var(--main-color);
          color: #fff;
        }
      }
    }

    .selector-item-box {
      padding: 15px;
    }

    .filter-body {
      height: 250px;
    }

    .left-menu {
      box-sizing: border-box;
      width: 88px;
      height: 250px;
      overflow-y: auto;
      background-color: #f7f7f7;
      @extend .font13;

      .menu-item {
        width: 100%;
        height: 56px;

        &.active {
          background-color: var(--main-color);
          color: #ffffff;
        }
      }

    }

    .right-block {
      box-sizing: border-box;
      flex: 1;
      height: 250px;
      overflow-y: auto;
      padding: 15px;

      p {
        height: 35px;
        line-height: 35px;
        @extend .font13;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        &.active {
          color: var(--main-color);
          font-weight: bold;
        }
      }
    }

    .btn-control {
      width: 100%;

      button {
        width: 50%;
        height: 40px;
        color: #fff;
        border: none;
        font-size: 14px;

        &.btn-reset {
          background-color: #E6E6E6;
          color: #666666;
        }

        &.btn-confirm {
          background-color: var(--main-color);
        }
      }
    }
  }
}

.news-items {

  .van-pull-refresh{
    min-height: 100vh;
    background: #fff;
    padding: 117px 15px 0px;
    box-sizing: border-box;
  }
  .news-box {
    margin-bottom: 15px;
  }

  .news-box:last-child {
    margin-bottom: 0;
  }
}
.empty{
  margin-top: 200px;
}
</style>